function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "156px",
    height: "36px",
    viewBox: "0 0 156 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,40%,100%)",
      fillOpacity: 1
    },
    d: "M 16.023438 17.335938 L 16.023438 9.109375 L 24.128906 9.109375 C 24.121094 13.652344 20.496094 17.335938 16.023438 17.335938 Z M 16.023438 26.890625 L 16.023438 18.664062 C 20.496094 18.664062 24.128906 22.347656 24.128906 26.890625 Z M 14.707031 17.335938 L 6.601562 17.335938 C 6.601562 12.789062 10.226562 9.109375 14.707031 9.109375 Z M 14.707031 26.890625 C 10.234375 26.890625 6.601562 23.210938 6.601562 18.664062 L 14.707031 18.664062 Z M 27.925781 7.363281 L 15.367188 0 L 2.796875 7.363281 C 1.0625 8.378906 0 10.25 0 12.277344 L 0 23.722656 C 0 25.75 1.0625 27.628906 2.796875 28.636719 L 15.367188 36 L 27.925781 28.636719 C 29.65625 27.621094 30.722656 25.75 30.722656 23.722656 L 30.722656 12.277344 C 30.722656 10.25 29.65625 8.378906 27.925781 7.363281 Z M 27.925781 7.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 49.523438 26.882812 C 52.679688 26.882812 55.457031 25.253906 56.882812 22.742188 L 54.4375 21.339844 C 53.554688 23.039062 51.679688 24.121094 49.523438 24.121094 C 45.835938 24.121094 43.390625 21.484375 43.390625 17.9375 C 43.390625 14.390625 45.835938 11.753906 49.523438 11.753906 C 51.667969 11.753906 53.527344 12.835938 54.4375 14.535156 L 56.882812 13.105469 C 55.4375 10.59375 52.652344 8.992188 49.523438 8.992188 C 44.320312 9 40.578125 12.941406 40.578125 17.9375 C 40.578125 22.941406 44.320312 26.882812 49.523438 26.882812 Z M 49.523438 26.882812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 61.796875 16.316406 L 61.796875 14.246094 L 59.152344 14.246094 L 59.152344 26.558594 L 61.796875 26.558594 L 61.796875 20.347656 C 61.796875 17.585938 63.824219 16.777344 65.554688 16.902344 L 65.554688 14.023438 C 64.023438 14.023438 62.527344 14.644531 61.796875 16.316406 Z M 61.796875 16.316406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 69.007812 21.535156 L 78.730469 21.535156 C 78.777344 21.195312 78.828125 20.800781 78.828125 20.429688 C 78.828125 16.882812 76.339844 13.933594 72.699219 13.933594 C 68.867188 13.933594 66.25 16.765625 66.25 20.410156 C 66.25 24.109375 68.867188 26.890625 72.894531 26.890625 C 75.292969 26.890625 77.125 25.882812 78.242188 24.210938 L 76.070312 22.933594 C 75.484375 23.796875 74.382812 24.460938 72.914062 24.460938 C 70.964844 24.445312 69.425781 23.453125 69.007812 21.535156 Z M 68.992188 19.367188 C 69.363281 17.523438 70.703125 16.335938 72.679688 16.335938 C 74.265625 16.335938 75.808594 17.242188 76.167969 19.367188 Z M 68.992188 19.367188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 90.757812 9.324219 L 90.757812 16.003906 C 89.832031 14.722656 88.386719 13.933594 86.484375 13.933594 C 83.167969 13.933594 80.398438 16.738281 80.398438 20.410156 C 80.398438 24.058594 83.15625 26.890625 86.484375 26.890625 C 88.386719 26.890625 89.832031 26.101562 90.757812 24.796875 L 90.757812 26.566406 L 93.402344 26.566406 L 93.402344 9.324219 Z M 86.898438 24.34375 C 84.699219 24.34375 83.039062 22.699219 83.039062 20.402344 C 83.039062 18.109375 84.699219 16.460938 86.898438 16.460938 C 89.101562 16.460938 90.757812 18.109375 90.757812 20.402344 C 90.757812 22.699219 89.101562 24.34375 86.898438 24.34375 Z M 86.898438 24.34375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 97.792969 12.402344 C 98.722656 12.402344 99.480469 11.609375 99.480469 10.699219 C 99.480469 9.765625 98.722656 9 97.792969 9 C 96.863281 9 96.105469 9.765625 96.105469 10.699219 C 96.105469 11.609375 96.863281 12.402344 97.792969 12.402344 Z M 96.476562 26.558594 L 99.117188 26.558594 L 99.117188 14.246094 L 96.476562 14.246094 Z M 96.476562 26.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 108.992188 16.8125 L 108.992188 14.246094 L 105.960938 14.246094 L 105.960938 10.800781 L 103.320312 11.59375 L 103.320312 14.257812 L 101.074219 14.257812 L 101.074219 16.820312 L 103.320312 16.820312 L 103.320312 22.734375 C 103.320312 25.9375 104.933594 27.070312 108.992188 26.578125 L 108.992188 24.191406 C 106.992188 24.289062 105.960938 24.316406 105.960938 22.742188 L 105.960938 16.828125 L 108.992188 16.828125 Z M 108.992188 16.8125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 130.6875 26.558594 L 123.527344 17.722656 L 130.445312 9.324219 L 127.097656 9.324219 L 120.597656 17.054688 L 120.597656 9.324219 L 117.785156 9.324219 L 117.785156 26.566406 L 120.597656 26.566406 L 120.597656 18.359375 L 127.34375 26.558594 Z M 130.6875 26.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 133.292969 21.535156 L 143.015625 21.535156 C 143.058594 21.195312 143.113281 20.800781 143.113281 20.429688 C 143.113281 16.882812 140.625 13.933594 136.984375 13.933594 C 133.148438 13.933594 130.535156 16.765625 130.535156 20.410156 C 130.535156 24.109375 133.148438 26.890625 137.179688 26.890625 C 139.578125 26.890625 141.410156 25.882812 142.527344 24.210938 L 140.355469 22.933594 C 139.769531 23.796875 138.667969 24.460938 137.199219 24.460938 C 135.242188 24.445312 133.710938 23.453125 133.292969 21.535156 Z M 133.265625 19.367188 C 133.636719 17.523438 134.980469 16.335938 136.957031 16.335938 C 138.542969 16.335938 140.085938 17.242188 140.445312 19.367188 Z M 133.265625 19.367188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 153.1875 14.246094 L 150.058594 23.183594 L 146.414062 14.246094 L 143.527344 14.246094 L 148.703125 26.34375 L 148.578125 26.585938 C 147.964844 28.214844 147.035156 29.097656 145.332031 28.996094 L 145.332031 31.480469 C 148.144531 31.652344 150.148438 30.078125 151.292969 26.945312 L 155.980469 14.238281 L 153.1875 14.238281 Z M 153.1875 14.246094 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d2b5b8d1e51113675a9a9d3750651b08.svg";
export { ForwardRef as ReactComponent };